var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoLocationServices = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "btn_taxes_and_commision24x24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10752",
    "data-name": "Rectangle 10752",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "placeholder",
    transform: "translate(-62.316 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29042",
    "data-name": "Group 29042",
    transform: "translate(67.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48235",
    "data-name": "Path 48235",
    d: "M75.317,0a6.609,6.609,0,0,0-6.5,6.7c0,2.066,1.032,4.574,3.068,7.454a32.744,32.744,0,0,0,3.02,3.674.576.576,0,0,0,.816.009,29.54,29.54,0,0,0,3.026-3.581c2.037-2.837,3.07-5.379,3.07-7.556A6.609,6.609,0,0,0,75.317,0Zm0,9.591a3.217,3.217,0,1,1,3.178-3.217A3.2,3.2,0,0,1,75.317,9.591Z",
    transform: "translate(-68.817)",
    fill: "#116984"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoLocationServices);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_location_services.0485c7000763ae33604c0cb9b2a512ec.svg";